import { render, staticRenderFns } from "./departmentMoneyNew.vue?vue&type=template&id=4c1cf94a&"
import script from "./departmentMoneyNew.vue?vue&type=script&lang=js&"
export * from "./departmentMoneyNew.vue?vue&type=script&lang=js&"
import style0 from "./departmentMoneyNew.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports